import { Box, Pressable } from '@rbilabs/universal-components';

import { Header } from 'components/app-header/styled';
import { getDesignToken } from 'styles/constants';
export const SignUpHeaderContainer = Box.withConfig<{ reversed?: boolean }>({
  background: getDesignToken('background-default'),
  backgroundColor: getDesignToken('background-default'),
});

export const SignUpHeader = Header.withConfig({
  backgroundColor: getDesignToken('background-default'),
});

export const BackArrowContainer = Pressable.withConfig({});
